import { Loader2 } from "lucide-react";
import { useFormStatus } from "react-dom";
import { Button, buttonVariants } from "@/shared/components/ui/button";
import { forwardRef } from "react";
import { VariantProps } from "class-variance-authority";

type LoadingButtonProps = React.ComponentProps<"button"> &
    VariantProps<typeof buttonVariants> & {
        loading?: boolean;
    };

const LoadingButton = forwardRef<HTMLButtonElement, LoadingButtonProps>(
    function LoadingButton({ loading, children, ...props }, ref) {
        const { pending } = useFormStatus();

        const isLoading = loading ?? pending;

        return (
            <Button ref={ref}  {...props} disabled={isLoading || props.disabled}>
                <>
                    {isLoading ? "Lütfen Bekleyin" : children}
                    {isLoading && <Loader2 className="animate-spin" />}
                </>
            </Button>
        );
    },
);

LoadingButton.displayName = "LoadingButton";

export { LoadingButton };